// extracted by mini-css-extract-plugin
export var actions = "_54-0";
export var actionsContainer = "_54-7";
export var border = "_54-1";
export var childFullHeight = "_54-f";
export var collapse = "_54-2";
export var content = "_54-a";
export var contentChild = "_54-e";
export var fullscreen = "_54-c";
export var hasLeftRadius = "_54-k";
export var headerContainer = "_54-3";
export var headerRow = "_54-5";
export var hidePadding = "_54-b";
export var navCollapsedGap = "_54-l";
export var noScrollX = "_54-m";
export var noScrollY = "_54-n";
export var noTopPadding = "_54-i";
export var optOutTopPadding = "_54-d";
export var pageMain = "_54-j";
export var pageOuter = "_54-g";
export var pagePadding = "_54-8";
export var pageScroll = "_54-9";
export var profile = "_54-o";
export var profileContainer = "_54-p";
export var profileImage = "_54-q";
export var profileMain = "_54-r";
export var profileSubtitle = "_54-t";
export var profileTitle = "_54-s";
export var showLeftPadding = "_54-h";
export var tabsPortalSlot = "_54-6";
export var tabsWrapper = "_54-4";
export var title = "_54-u";